<template>
  <div>
    <div class=" mainLoader" v-if="loading"></div>
    <div class="realbody">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="row mt-3">
              <div v-if="role != 'engineer'" class="col-md-12 text-left">
                   <router-link :to="{ name: 'companyRecuritAdd', params: {cid: companyId, uid: userId}, query: {id:recruitId} }">
                    <span class="btn bluebtn mplus2p-r rlistbtn" style="float: right;">
                        <span style="font-size: 1.4rem;">+</span>&nbsp;&nbsp;
                        <span>{{$t('recruit_copy')}}</span>
                    </span>
                  </router-link>
              </div>
              <div class="col-md-2 text-center">
                <video v-if="c_video"   height="150" width="150" controls autoplay loop>
                  <source :src="c_video">
                </video>

                <img v-if="c_image" class="smallcimg mb-1" :src="c_image" />

              </div>
              <div class="col-md-10" style="margin-top: 80px;">
                <div class="row">
                  <div class="col-md-12">
                    <h3
                      class="comtitle mplus2p-m spacing0-7 noiseblack" :class="{'companyDetailPointer' : role == 'engineer'}"
                      @click="companyDetails(c_id)">
                      {{c_name}}
                    </h3>
                  </div>
                  <div v-if="role == 'engineer' && interview_completed" class="col-md-12">
                    <button v-if="!testUser"
                      class="btn whitebtn clickcbtn"
                      :class="{like : favorited_recruit.pivot}"
                      @click="onFavClickRecruit(recruitId)">
                       <i class="fa fa-heart margin-r-5"></i>
                    </button>

                    <button v-if="!testUser"
                      class="btn whitebtn clickcbtn"
                      @click="sandMsg(c_id)"
                      style="margin-right: 10px;">
                      <i class="fa fa-envelope margin-r-5"></i>
                    </button><div v-if="want_to_talk_casually" class="casually">{{$t('speech_bubble')}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      <div class="col-md-12">
        <div class="row" style="margin-top: 10px;">
          <div class="col-md-12">
            <div class="row">
              <div v-if="manager_comments && role == 'engineer'" class="comment-block">
                <p class="comment-title">{{$t('comments_manager')}}</p>
                <p class="comment-desc">{{manager_comments}}</p>
              </div>
              <!-- subject -->
              <div class="col-md-12">
                <h3 class="rc_firsttitle mplus2p-m spacing1-2 noiseblack text-justify">{{r_subject}}</h3>
                <div style="height: 20px;">
                  <hr style="border-width: 2px; border-color: #3d7dd8; width: 20%; float: left;" />
                  <hr style="border-width: 2px; border-color: #f8fafa; width: 80%; float: left;" />
                </div>
              </div>

              <!-- content -->
              <template>
                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-3">
                  <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('cr_content')}}</p>
                </div>
                <div class="col-md-9">
                  <p
                    class="rc_firstcontent mplus2p-m spacing1-2 noiseblack"
                    style="height: auto;text-align:justify;white-space:pre-wrap;-webkit-box-orient: vertical"
                    v-html="urlify(r_content)"></p>
                </div>
              </template>

                <!-- skill keyword -->
              <template v-if="skill_keyword.length > 0">
                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-3">
                  <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('cr_skill_keyword')}}</p>
                </div>
                <div class="col-md-9">
                  <div class="tech2">
                    <span
                      class="layer2"
                      v-for="(item, index) in skill_keyword"
                      :key="index">{{ lan == 'en'? item.check_content:item.jp_check_content}}</span>
                  </div>
                </div>
              </template>

               <!-- company hire engineer -->
              <template v-if="why_hire_engineer">
                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-3">
                  <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('company_hire_engineer')}}</p>
                </div>
                <div class="col-md-9">
                  <p
                    v-if="lan == 'en'"
                    class="mplus2p-m spacing1-2 noiseblack"
                  >{{why_hire_engineer.en_reason}}</p>
                  <p
                    v-if="lan == 'jp'"
                    class="mplus2p-m spacing1-2 noiseblack"
                  >{{why_hire_engineer.jp_reason}}</p>
                </div>
              </template>

              <!-- recruitment tention -->
              <template v-if="recruitment_tension">
                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-3">
                  <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('recruitment_tension')}}</p>
                </div>
                <div class="col-md-9">
                  <p
                    v-if="lan == 'en'"
                    class="mplus2p-m spacing1-2 noiseblack"
                  >{{recruitment_tension.en_tension}}</p>
                  <p
                    v-if="lan == 'jp'"
                    class="mplus2p-m spacing1-2 noiseblack"
                  >{{recruitment_tension.jp_tension}}</p>
                </div>
              </template>

              <!-- full time / part time -->
              <template v-if="freelance_type.length > 0">
                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-3">
                  <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('job_type')}}</p>
                </div>
                <div class="col-md-9">
                  <div class="tech2">
                    <span
                      class="layer2"
                      v-for="(item, index) of freelance_type"
                      :key="index"
                    >{{ lan == 'en'? item.en_type:item.jp_type}}</span>
                  </div>
                </div>
              </template>

             <!-- Supplement of full time/ part time -->
              <template v-if="supplement_time != null">
                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-3">
                  <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('cr_supplement_fulltime_parttime')}}</p>
                </div>
                <div class="col-md-9">
                  <p
                    class="rc_firstcontent mplus2p-m spacing1-2 noiseblack"
                    style="height: auto;text-align:justify;white-space:pre-wrap;-webkit-box-orient: vertical"
                    v-html="urlify(supplement_time)"></p>
                </div>
              </template>

             <!-- payments -->
              <template v-if="payments.length > 0">
                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-3">
                  <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('payment_text')}}</p>
                </div>
                <div class="col-md-9">
                  <div class="job-main" v-for="(item, index) in payments" :key="index">
                    <div class="row">
                      <div class="col-md-2">
                        <p
                      class="rc_firstcontent mplus2p-m spacing1-2 noiseblack"
                      style="height: auto;text-align:justify;white-space:pre-wrap;-webkit-box-orient: vertical"
                      >{{lan == 'en'? item.freelance_type.en_type : item.freelance_type.jp_type}}</p>
                      </div>
                      <div class="col-md-10">
                        <p
                      class="rc_firstcontent mplus2p-m spacing1-2 noiseblack"
                      style="height: auto;text-align:justify;white-space:pre-wrap;-webkit-box-orient: vertical"
                      >:     {{lan == 'en'? item.income_type.en_type : item.income_type.jp_type}} {{item.lower_limit != 0 ? item.lower_limit.toLocaleString() : ''}} {{item.lower_limit != 0 ? $t('yen') : ''}} ~ {{item.upper_limit != 0 && item.upper_limit ? item.upper_limit.toLocaleString() : ''}} {{item.upper_limit != 0 && item.upper_limit ? $t('yen') : ''}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </template>

              <!-- location -->
              <template v-if="location">
                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-3">
                  <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('cr_work_location')}}</p>
                </div>
                <div class="col-md-9">
                  <p
                    class="rc_firstcontent mplus2p-m  spacing1-2 noiseblack"
                    style="height: auto;text-align:justify;white-space:pre-wrap;-webkit-box-orient: vertical"
                  >{{location}}</p>
                </div>
              </template>

              <!-- contract type -->
              <template v-if="contract_type.length > 0">
                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-3">
                  <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('contract')}}</p>
                </div>
                <div class="col-md-9">
                  <div class="tech2">
                    <span
                      class="layer2"
                      v-for="(item, index) of contract_type"
                      :key="index"
                    >{{ lan == 'en'? item.en_type:item.jp_type}}</span>
                  </div>
                </div>
              </template>



               <!-- Supplement of type of contract -->
              <template v-if="supplement_contract != null">
                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-3">
                  <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('cr_supplement_contract')}}</p>
                </div>
                <div class="col-md-9">
                  <p
                    class="rc_firstcontent mplus2p-m spacing1-2 noiseblack"
                    style="height: auto;text-align:justify;white-space:pre-wrap;-webkit-box-orient: vertical"
                    v-html="urlify(supplement_contract)"></p>
                </div>
              </template>

              <!-- technical skill -->
              <template v-if="technique_skill">
                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-3">
                  <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('required_technique_skill')}}</p>
                </div>
                <div class="col-md-9">
                  <p
                    class="rc_firstcontent mplus2p-m  spacing1-2 noiseblack"
                    style="height: auto;text-align:justify;white-space:pre-wrap;-webkit-box-orient: vertical"
                    v-html="urlify(technique_skill)"></p>
                </div>
              </template>

              <!-- better technique skill -->
              <template v-if="better_technique_skill">
                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-3">
                  <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">
                    {{$t('better_technique_skill_if_there_is')}}</p>
                </div>
                <div class="col-md-9">
                  <p
                    class="rc_firstcontent mplus2p-m spacing1-2 noiseblack"
                    style="height: auto;text-align:justify;white-space:pre-wrap;-webkit-box-orient: vertical"
                    v-html="urlify(better_technique_skill)"></p>
                </div>
              </template>

              <!-- personality -->
              <template v-if="personality">
                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-3">
                  <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('required_personality')}}</p>
                </div>
                <div class="col-md-9">
                  <p
                    class="rc_firstcontent mplus2p-m spacing1-2 noiseblack"
                    style="height: auto;text-align:justify;white-space:pre-wrap;-webkit-box-orient: vertical"
                    v-html="urlify(personality)"></p>
                </div>
              </template>

              <!-- any request -->
              <template v-if="any_request">
                <div class="col-md-12" style="height: 15px;"
                ></div>
                <div class="col-md-3">
                  <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('any_request')}}</p>
                </div>
                <div class="col-md-9">
                  <p
                    class="rc_firstcontent mplus2p-m spacing1-2 noiseblack"
                    style="height: auto;text-align:justify;white-space:pre-wrap;-webkit-box-orient: vertical"
                    v-html="urlify(any_request)"></p>
                </div>
              </template>


              <!-- Benefits for engineers -->
              <template v-if="en_benefits != null">
                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-3">
                  <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('cr_bebefit_engineer')}}</p>
                </div>
                <div class="col-md-9">
                  <p
                    class="rc_firstcontent mplus2p-m spacing1-2 noiseblack"
                    style="height: auto;text-align:justify;white-space:pre-wrap;-webkit-box-orient: vertical"
                    v-html="urlify(en_benefits)"></p>
                </div>
              </template>

              <!-- Recruit role-->
              <template v-if="recruit_role != null">
                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-3">
                  <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('cr_recruit_role')}}</p>
                </div>
                <div class="col-md-9">
                  <p
                    class="rc_firstcontent mplus2p-m spacing1-2 noiseblack"
                    style="height: auto;text-align:justify;white-space:pre-wrap;-webkit-box-orient: vertical"
                    v-html="urlify(recruit_role)"></p>
                </div>
              </template>

              <!-- How to proceed with project / development -->
              <template v-if="how_to_proceed != null">
                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-3">
                  <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('cr_process_project')}}</p>
                </div>
                <div class="col-md-9">
                  <p
                    class="rc_firstcontent mplus2p-m spacing1-2 noiseblack"
                    style="height: auto;text-align:justify;white-space:pre-wrap;-webkit-box-orient: vertical"
                    v-html="urlify(how_to_proceed)"></p>
                </div>
              </template>

              <!-- Current structure -->
              <template v-if="current_structure != null">
                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-3">
                  <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('cr_current_structure')}}</p>
                </div>
                <div class="col-md-9">
                  <p
                    class="rc_firstcontent mplus2p-m spacing1-2 noiseblack"
                    style="height: auto;text-align:justify;white-space:pre-wrap;-webkit-box-orient: vertical"
                    v-html="urlify(current_structure)"></p>
                </div>
              </template>

              <!-- Technique Stack -->
              <template v-if="technique_stack != null">
                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-3">
                  <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('cp_technique_stack')}}</p>
                </div>
                <div class="col-md-9">
                  <p
                    class="rc_firstcontent mplus2p-m spacing1-2 noiseblack"
                    style="height: auto;text-align:justify;white-space:pre-wrap;-webkit-box-orient: vertical"
                    v-html="urlify(technique_stack)"></p>
                </div>
              </template>

              <div class="col-md-12" style="margin-top: 40px; margin-bottom: 30px">
                <h3 class="rc_firsttitle mplus2p-m spacing1-2 noiseblack">{{$t('cd_about')}}</h3>
                <div style="height: 20px;">
                  <hr style="border-width: 2px; border-color: #3d7dd8; width: 20%; float: left;" />
                  <hr style="border-width: 2px; border-color: #f8fafa; width: 80%; float: left;" />
                </div>
              </div>

              <template v-if="c_name">
                <div class="col-md-3">
                  <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('cp_name')}}</p>
                </div>
                <div class="col-md-9">
                  <p class="mplus2p-m spacing1-2 noiseblack">{{c_name}}</p>
                </div>
              </template>

              <template v-if="c_location">
                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-3">
                  <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('cp_location')}}</p>
                </div>
                <div class="col-md-9">
                  <p class="mplus2p-m spacing1-2 noiseblack">{{c_location}}</p>
                </div>
              </template>

              <template v-if="c_esablishment">
                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-3">
                  <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('cp_establishment')}}</p>
                </div>
                <div class="col-md-9">
                  <p class="mplus2p-m spacing1-2 noiseblack">{{c_esablishment}}</p>
                </div>
              </template>

              <template v-if="c_representative">
                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-3">
                  <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('cp_representative')}}</p>
                </div>
                <div class="col-md-9">
                  <p class="mplus2p-m spacing1-2 noiseblack">{{c_representative}}</p>
                </div>
              </template>

              <template v-if="c_enterprise_url">
                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-3">
                  <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('cp_e_url')}}</p>
                </div>
                <div class="col-md-9">
                  <p
                    class="mplus2p-m spacing1-2 noiseblack link"
                    @click="navigateToUrl(c_enterprise_url)"
                  >{{c_enterprise_url}}</p>
                </div>
              </template>

              <template v-if="c_NOE">
                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-3">
                  <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('cp_noe')}}</p>
                </div>
                <div class="col-md-9">
                  <p class="mplus2p-m spacing1-2 noiseblack">{{c_NOE}}</p>
                </div>
              </template>

              <template v-if="c_job_category">
                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-3">
                  <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('cp_job_cat')}}</p>
                </div>
                <div class="col-md-9">
                  <p class="mplus2p-m spacing1-2 noiseblack">{{c_job_category}}</p>
                </div>
              </template>

              <template v-if="c_engineer_experience">
                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-3">
                  <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('cp_engineer_experience')}}</p>
                </div>
                <div class="col-md-9">
                  <p class="mplus2p-m spacing1-2 noiseblack">{{c_engineer_experience}}</p>
                </div>
              </template>

              <template v-if="c_desc">
                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-3">
                  <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('cp_company_desc')}}</p>
                </div>
                <div class="col-md-9">
                  <p
                    class="rc_firstcontent mplus2p-m spacing1-2 noiseblack"
                    style="height: auto;text-align:justify;white-space:pre-wrap;-webkit-box-orient: vertical"
                    v-html="urlify(c_desc)"></p>
                </div>
              </template>

              <template v-if="c_recruitment_situation">
                <div class="col-md-12" style="height: 15px;" ></div>
                <div class="col-md-3">
                  <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('recruitment_situation')}}</p>
                </div>
                <div class="col-md-9">
                  <p class="mplus2p-m spacing1-2 noiseblack">{{lan == 'en' ? c_recruitment_situation.en_situation : c_recruitment_situation.jp_situation}}</p>
                </div>
              </template>

            </div>
            <div v-if="role == 'engineer' && interview_completed" class="row">
              <div class="col-md-12">
                <button v-if="!testUser"
                  class="btn whitebtn clickcbtn"
                  :class="{like : favorited_recruit.pivot}"
                  @click="onFavClickRecruit(recruitId)">
                    <i class="fa fa-heart margin-r-5"></i>
                </button>

                <button  v-if="!testUser"
                  class="btn whitebtn clickcbtn"
                  @click="sandMsg(c_id)"
                  style="margin-right: 10px;">
                  <i class="fa fa-envelope margin-r-5"></i>
                </button>
                <div v-if="want_to_talk_casually" class="casually">{{$t('speech_bubble')}}</div>
              </div>
            </div>

          </div>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import Hashids from "hashids";
import NavSidebar from "./company_sidebar";
import axios from "axios";
import { EventBus } from "../../main.js";

export default {
  data() {
    return {
      lan: "jp",
      loading: false,
      testUser: 0,
      r_image: "",
      c_id: 0,
      c_name: "",
      c_image: "",
      c_video: "",
      c_location: "",
      c_esablishment: "",
      c_representative: "",
      c_enterprise_url: "",
      c_NOE: "",
      c_industry: "",
      c_job_category: "",
      c_engineer_experience: "",
      c_desc: "",
      c_idea: "",
      c_vision: "",
      c_recruitment_situation: "",
      r_subject: "",
      r_content: "",
      technique_skill: "",
      better_technique_skill: "",
      personality: "",
      any_request: "",
      location: "",
      categories: [],
      recruitId: "",
      favorite_recruit: [],
      favorited_recruit: {},
      recruitment_tension: "",
      contract_type: [],
      freelance_type: [],
      why_hire_engineer: "",
      role: "",
      interview_completed: '',
      supplement_time: "",
      supplement_contract: "",
      manager_comments: '',
      en_benefits: "",
      recruit_role: "",
      how_to_proceed: "",
      current_structure: "",
      technique_stack: "",
      skill_keyword: [],
      want_to_talk_casually: '',
      payments: [],
      userId: '',
      companyId: ''
    };
  },
  created() {
    this.role = localStorage.getItem("role");
    if (process.env.RECRUIT_HIDE_FLAG === 'true') {
      this.$router.push("/global/PageNotFound");
    }
    this.recruitId = this.$route.params.rid;

    var data = JSON.parse(localStorage.getItem("user"));
    this.userId = data.user_token;
    if (data.company) {
      this.companyId = data.company.company_token;
    }

    this.getRecruitDetail();
    if ("lan" in localStorage) {
      this.lan = localStorage.getItem("lan");
    }
  },
  mounted() {
    EventBus.$on("language", data => {
      this.lan = data;
    });
    if (localStorage.getItem("role") == "engineer") {
      var retrievedData = localStorage.getItem("user");
      var data = JSON.parse(retrievedData);
      this.testUser = data.test_user;
      this.interview_completed = data.completed_interview;
    }
  },
  components: {
    appSideBar: NavSidebar
  },
  methods: {
    companyDetails(cid) {
      if (this.role == 'engineer') {
        var hashids = new Hashids(
        "CompanyIds",
        8,
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890"
        );
        let routeData = this.$router.resolve({
          name: "companyDetail",
          params: { cid: hashids.encode(cid) }
        });
        window.open(routeData.href, "_blank");
        }
    },
    urlify(text) {
      var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
      //var urlRegex = /(https?:\/\/[^\s]+)/g;
      return text.replace(urlRegex, function(url,b,c) {
          var url2 = (c == 'www.') ?  'http://' +url : url;
          return '<a href="' +url2+ '" target="_blank">' + url + '</a>';
      })
    },
    sandMsg(cid) {
      var hashids = new Hashids(
        "this is my salt",
        8,
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890"
      );
      this.$router.push("/global/chatroom/" + hashids.encode(cid));
    },
    onFavClickRecruit(id) {
      var token = localStorage.getItem("token");
      var vm = this;
      const formData = {
        recruit_id: id
      };
      this.favorited_recruit.pivot = !this.favorited_recruit.pivot;
      this.$forceUpdate();
      axios
        .post("/favorite/recruit?token=" + token, formData, {
          headers: { "X-localization": localStorage.getItem("lan") }
        })
        .then(res => {
          if (!res.data.result) {
            if (res.data.data.message) {
              this.$toaster.error(res.data.data.message);
              this.favorited_recruit.pivot = !this.favorited_recruit.pivot;
              this.$forceUpdate();
            }
          } else {
            if (res.data.liked) {
              this.$toaster.success(vm.$t("success_recruit_favorited"));
            } else {
              this.$toaster.error(vm.$t("err_recruit_favorited"));
            }
          }
        });
    },
    filterFavoriterRecruit() {
      var index = this.favorite_recruit.findIndex(obj => {
        if (obj.pivot.recruit_id == this.recruitId) {
          return true;
        }
      });
      if (index != -1) {
        this.favorited_recruit = { pivot: true };
      } else {
        this.favorited_recruit = { pivot: false };
      }
      this.$forceUpdate();
    },
    getFavoriterRecruit() {
      var token = localStorage.getItem("token");
      axios
        .get("/favorited/recruit?token=" + token)
        .then(res => {
          if (!res.data.result) {
            if (res.data[0]) {
              this.$toaster.error(res.data[0]);
              this.$store.dispatch("logout");
            }
          } else {
            var index = 1;
            for (var i = 0; i < res.data.recruits.data.length; i++) {
              this.favorite_recruit = res.data.recruits.data;
            }
            index++;
            this.filterFavoriterRecruit();
          }
        })
        .catch(error => console.log(error));
    },
    getRecruitDetail() {
      this.loading = true;
      var token = localStorage.getItem("token");
      axios
        .get("recruit/detail/" + this.recruitId + "?token=" + token, {
          headers: { "X-localization": localStorage.getItem("lan") }
        })
        .then(res => {
          if (res.data[0]) {
            this.$toaster.error(res.data[0]);
            this.$store.dispatch("logout");
            this.loading = false;
          }
          if (!res.data.result) {
            if (res.data.errors)
              for (var i = 0; i < res.data.errors.length; i++) {
                this.$toaster.error(res.data.errors[i].message);
                this.$router.push("/global/PageNotFound");
              }
            this.loading = false;
          } else {
            try {
              this.loading = false;
              this.c_id = res.data.data.company.id;
              this.c_name = res.data.data.company.name;
              if (res.data.data.company.image.split(/\#|\?/)[0].split('.').pop().trim() === 'mp4') {
                this.c_video = res.data.data.company.image
              }else{
                this.c_image = res.data.data.company.image
              }
              this.c_location = res.data.data.company.location;
              this.c_esablishment = res.data.data.company.establishment_year;
              this.c_representative = res.data.data.company.representative;
              this.c_recruitment_situation =
                res.data.data.company.recruitment_situation;
              this.c_enterprise_url = res.data.data.company.enterprise_url;
              this.c_job_category = res.data.data.company.job_category;
              this.c_engineer_experience =
                res.data.data.company.engineer_experience;
              this.c_NOE = res.data.data.company.number_of_employees;
              this.c_desc = res.data.data.company.company_description;
              this.c_idea = res.data.data.company.idea;
              this.c_vision = res.data.data.company.vision;
              this.r_subject = res.data.data.recruit.subject;
              this.r_content = res.data.data.recruit.content;
              this.payments = res.data.data.recruit.payments;
              this.location = res.data.data.recruit.location;
              this.technique_skill = res.data.data.recruit.technique_skill;
              this.better_technique_skill =
                res.data.data.recruit.better_technique_skill;
              this.personality = res.data.data.recruit.personality;
              this.any_request = res.data.data.recruit.any_request;
              this.manager_comments = res.data.data.recruit.manager_comments;
              this.r_image = res.data.data.recruit.image;
              this.recruitment_tension =
                res.data.data.recruit.recruitment_tension;
              this.contract_type = res.data.data.recruit.contract_types;
              this.freelance_type = res.data.data.recruit.freelance_types;
              this.why_hire_engineer = res.data.data.recruit.why_hire_engineer;
              this.want_to_talk_casually = res.data.data.want_to_talk_casually;
              this.supplement_time = res.data.data.recruit.supplement_time
              this.supplement_contract = res.data.data.recruit.supplement_contract
              this.en_benefits = res.data.data.recruit.en_benefits
              this.recruit_role = res.data.data.recruit.recruit_role
              this.how_to_proceed = res.data.data.recruit.how_to_proceed
              this.current_structure = res.data.data.recruit.current_structure
              this.technique_stack = res.data.data.recruit.technique_stack
              this.skill_keyword = res.data.data.recruit.skill_keyword
              this.getFavoriterRecruit();
            } catch (error) {}
          }
        })
        .catch(error => console.log(error));
    },
    navigateToUrl(url) {
      window.open(url, "_blank");
    }
  }
};
</script>

<style scoped>
.like .fa {
  color: #fc033b;
  text-shadow: 1px 1px 1px #ccc;
}
.casually{
  background: #3f7ed8;
  color: white;
  padding: 10px;
  border-radius: 6px;
  float: right;
  margin-right: 15px
}
.casually::after{
    content: '';
    position: absolute;
    right: 112px;
    width: 0;
    height: 0;
    border: 10px solid transparent;
    border-left-color: #3f7ed8;

}
.comment-block{
  width: 100%;
  border: 2px solid #3f7ed8;
  padding: 10px 25px 10px 25px;
  border-radius: 20px;
  margin-top: 15px !important;
  margin-left: 15px !important;
}
.comment-title{
  color: #3f7ed8;
  font-size: 1rem;
  text-decoration: underline;
  margin-bottom: 5px;
}
.comment-desc{
  white-space: pre-line;
  word-break: break-all;
  font-size: 1rem;
  margin: 0;
  color: #3f7ed8;
}
.recruit-detail-image {
  width: 100%;
  height: 110px;
}
.companyDetailPointer:hover {
  cursor: pointer;
  text-decoration: underline;
}
.clickcbtn {
  border-radius: 20px;
  padding: 7px 14px;
  box-shadow: 0 1px 4px 0 rgba(40, 60, 80, 0.4);
  float: right;
}
.tech2 {
  margin-right: 5px;
  margin-bottom: 10px;
}

.layer2 {
  border: 2px solid #3d7dd8;
  /* font-size: 1rem; */
  /* font-weight: 400; */
  font-style: normal;
  font-stretch: extra-condensed;
  letter-spacing: 0.4px;
  color: #3d7dd8;
  padding: 5px;
  margin-right: 5px;
  white-space: pre;
  word-break: keep-all;
  display: inline-block;
  border-radius: 11px;
  margin-bottom: 10px;
}
.link {
  cursor: pointer;
  color: blue;
}
.link:hover {
  text-decoration: underline;
}
pre {
  font-size: 1em;
}
.searchbox {
  height: 40px;
  border-radius: 4px;
  background-color: #f0f2f4;
  border: 1px solid #58606800;
}

.input-group-append {
  border-top-right-radius: 6.4px;
  border-bottom-right-radius: 6.4px;
  background-color: #3d7dd8;
}

.input-group-append button {
  color: white;
  border: 1px solid #58606800;
}

.input-group-append:hover button {
  color: #3d7dd8 !important;
}

.btn-outline-secondary:hover {
  background-color: white;
  color: #3d7dd8 !important;
}

.tech-skill {
  border: solid 1px #3d7dd8;
  padding: 7px 10px;
  border-radius: 7px;
  color: #3d7dd8;
  margin-right: 10px;
}

.extxt {
  font-size: 0.75rem;
  font-weight: 500;
  color: rgba(60, 80, 100, 0.8);
}

.checklabel {
  font-size: 0.8125rem;
  font-weight: 500;
}

.styled-checkbox + label:before {
  margin-right: 12px;
  margin-top: -2px;
}

.checkgrouplabel {
  font-size: 1rem;
  font-weight: 500;
}

.checkgrouppanel {
  margin-top: 45px;
}

.unstyled {
  margin-top: 13px;
}

.unstyled li {
  margin-top: 1px;
}

li:after {
  content: "\f107";
  font-family: FontAwesome;
  font-size: 22px;
  position: absolute;
  right: 30px;
  color: #6474847d;
  margin-top: -2px;
}

.rec_detail_title {
  font-size: 1.5rem;
  font-weight: 500;
}

.toppart {
  margin-top: 120px;
}
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}
.smallcimg {
 margin-top: 40px;
    width: 130px;
    height: 130px;
    -o-object-fit: contain;
    object-fit: contain;
    -o-object-position: center;
    object-position: center;
}

.comtitle {
  font-size: 1.5rem;
  font-weight: 500;
}

.tagtip {
  height: 24px;
  color: white;
  padding: 5px;
  font-size: 0.8rem;
  font-weight: 500;
  border-radius: 4px;
  margin-left: 10px;
}

.rec_top_first {
  margin-top: 30px;
}

.rec_top_second {
  margin-top: 25px;
}

.enrtybtn {
  width: 100%;
  height: 48px;
  border-radius: 24px;
  box-shadow: 0 1px 4px 0 rgba(40, 60, 80, 0.4);
  font-size: 1rem !important;
}

.rc_firsttitle {
  font-size: 1.5rem;
  font-weight: 500;
  margin-top: 25px;
}

.rc_firstcontent {
  font-size: 1rem;
  font-weight: 500;
  line-height: 2;
  text-align: justify;
  word-wrap: break-word;
}

.pgraytxt {
  opacity: 0.64;
  font-size: 1.2rem;
  font-weight: 600;
}

@media screen and (max-width: 400px) {
  .tagtip {
    float: right;
  }
}
.pgraytxt {
  text-transform: capitalize;
}
</style>
